"use strict";

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/**
 * Copyright 2015-present Facebook. All Rights Reserved.
 *
 * @format
 * 
 * @emails oncall+internationalization
 */
var FbtReactUtil = require("./FbtReactUtil");

var FbtResultBaseImpl = require("./FbtResultBaseImpl");

var cx = require("fbjs/lib/cx");

function em(content, inlineMode, translation, hash) {
  // TODO: in the future, might depend on the translation status of the
  // string to decide on the proper inline mode.
  var className = cx('intlInlineMode/normal');

  if (hash != null && hash != '') {
    if (inlineMode === 'TRANSLATION') {
      className = cx('intlInlineMode/translatable');
    } else if (inlineMode === 'APPROVE') {
      className = cx('intlInlineMode/approvable');
    } else if (inlineMode === 'REPORT') {
      className = cx('intlInlineMode/reportable');
    }
  }

  return {
    $$typeof: FbtReactUtil.REACT_ELEMENT_TYPE,
    type: 'em',
    key: null,
    ref: null,
    props: {
      // get the correct hash and trid when the data is available
      className: className,
      'data-intl-hash': hash,
      'data-intl-translation': translation,
      'data-intl-trid': '',
      children: content,
      // TODO (t22619936): This is because hack's fbt em tags don't match up to
      // the em tags produced here. Disabling hydration warnings prevents
      // spewing a hydration error anywhere server-side rendering is used with
      // fbt and then hydrated.
      suppressHydrationWarning: true
    },
    _owner: null
  };
}

var InlineFbtComponent = function InlineFbtComponent(props) {
  return em(props.content, props.inlineMode, props.translation, props.hash);
};

var InlineFbtResult =
/*#__PURE__*/
function (_FbtResultBaseImpl) {
  _inheritsLoose(InlineFbtResult, _FbtResultBaseImpl);

  function InlineFbtResult(contents, inlineMode, translation, hash) {
    var _this;

    _this = _FbtResultBaseImpl.call(this, contents) || this;
    /* eslint-disable fb-www/react-state-props-mutation */

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "$$typeof", FbtReactUtil.REACT_ELEMENT_TYPE);

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "key", null);

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "props", void 0);

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "ref", null);

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "type", InlineFbtComponent);

    _this.props = {
      content: contents,
      inlineMode: inlineMode,
      translation: translation,
      hash: hash
    };

    if (process.env.NODE_ENV !== "production") {
      FbtReactUtil.defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), '_store', {
        validated: true
      });
    }

    return _this;
  }

  return InlineFbtResult;
}(FbtResultBaseImpl);

module.exports = InlineFbtResult;